import axios from 'axios'
import Chart from 'chart.js'

import {
  getParameterOfTheUrl,
} from './plugins/helper'

const getTimerReport = async () => {
  const object = getParameterOfTheUrl(window.location.search)
  const value = object && Object.keys(object).length > 0 ? object.semanal_id : 1
  const baseUrl = (window.config && window.config.appUrl) ? window.config.appUrl : ''
  return axios.get(`${baseUrl}/api/home/weekly_blog/report/${value}`)
}
const promise = getTimerReport()
promise.then(response => {
  const { data } = response

  new Chart(
    'chart-2',
    {
      type: 'bar',
      data,
      options: {
        title: {
          display: true,
          text: 'FECHA DE CIERRE',
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true,
          }],
        },
      },
    },
  )
})
